module.exports = __webpack_public_path__ + "img/info-bg.50e044bf.png";